import { TextAreaField } from '@aws-amplify/ui-react'
import { SwapHorizOutlined } from '@mui/icons-material'
import { Alert, Box, Stack } from '@mui/material'
import { AxiosError } from 'axios'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import PageHeader from '@/components/layouts/PageHeader'
import { useAlertContext } from '@/contexts/AlertContext'
import SubmitButton from '@/features/bidding/components/SubmitButton'
import {
  useIsSwitchingResources,
  useSwitchResourcesMutation,
} from '@/features/resourceSwitchboard/hooks/useSwitchResourcesMutation'

export default function ResourceSwitchboardIndex() {
  const { t } = useTranslation()
  const { pushAlert } = useAlertContext()
  const isSwitchingResources = useIsSwitchingResources()
  const [tsvRows, setTsvRows] = useState<string>('')
  const { switchResources } = useSwitchResourcesMutation()

  const onSubmit = async () => {
    await switchResources(tsvRows)
      .then((response) => {
        setTsvRows('')
        pushAlert({
          message: response.data,
          severity: 'info',
          title: t('resource_switchboard.sending_successful.title'),
        })
      })
      .catch((error) => {
        const message =
          error instanceof AxiosError && error.response?.data?.message
            ? error.response.data.message
            : (error.message ?? t('resource_switchboard.sending_failed.unknown_error'))
        pushAlert({
          message,
          severity: 'error',
          title: t('resource_switchboard.sending_failed.title'),
        })
      })
  }

  const dialogProps = {
    title: t('resource_switchboard.dialog.title'),
    description: t('resource_switchboard.dialog.description'),
  }

  return (
    <>
      <PageHeader pageTitle={t('component.page_header.resource_switchboard')} />

      <Stack direction="column" mt={2} spacing={2}>
        <Alert severity="warning">{t('resource_switchboard.notice')}</Alert>

        <TextAreaField
          data-testid="tsv-rows"
          label={t('resource_switchboard.tsv')}
          placeholder={t('resource_switchboard.tsv_placeholder')}
          resize="vertical"
          rows={10}
          value={tsvRows}
          onChange={(e) => setTsvRows(e.target.value)}
        />

        <Box data-testid="submit-button">
          <SubmitButton
            buttonProps={{
              startIcon: <SwapHorizOutlined />,
              disabled: isSwitchingResources || tsvRows == '',
            }}
            dialogProps={dialogProps}
            shouldShowConfirmation={true}
            onSubmit={onSubmit}
          >
            {t('resource_switchboard.submit')}
          </SubmitButton>
        </Box>
      </Stack>
    </>
  )
}
